// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whatsNewPage__Lqxui {
  height: 100%;
}

.whatsNewBody__SkwSp {
  overflow-y: auto;
  padding: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: calc(100% - 55px);
}
.whatsNewBody__SkwSp::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.whatsNewBody__SkwSp::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.whatsNewBody__SkwSp::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.whatsNewBody__SkwSp::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/WhatsNew/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;AAzEF;;AA4EA;EAEE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;AA1EF;AAeE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,+BAAA;EACA,kBAAA;AAdJ;AAiBE;EACE,8BAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,kBAAA;AAhBJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.whatsNewPage {\n  height: 100%;\n}\n\n.whatsNewBody {\n  @include scrollBar;\n  overflow-y: auto;\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  height: calc(100% - 55px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whatsNewPage": `whatsNewPage__Lqxui`,
	"whatsNewBody": `whatsNewBody__SkwSp`
};
module.exports = ___CSS_LOADER_EXPORT___;
